import ProjectTemplatesClient from "./generated/projectTemplates/client";
import raw from "./rawClients/rawProjectTemplatesClient";
const NAME = "projectTemplatesClient";
const client = new ProjectTemplatesClient(raw);
// Map methods to object for compatibility with mockClient
const projectTemplatesClient = {};
Object.getOwnPropertyNames(ProjectTemplatesClient.prototype).forEach(name => {
  if (name === "constructor") {
    return;
  }
  projectTemplatesClient[name] = client[name].bind(client);
});
// ensure `NAME` is readonly.
Object.defineProperty(projectTemplatesClient, "NAME", {
  get: () => NAME,
});
export default projectTemplatesClient;
